import { getWarehouses, getObjectsState, selectWarehouses } from 'containers/Warehouses/warehousesSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxSelector, useReduxDispatch } from 'store'
import { useEffect } from 'react'

const useWarehouses = (withState = false) => {
  const warehouses = useReduxSelector(selectWarehouses)
  const clientId = useReduxSelector(selectUserId)
  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (clientId) {
      dispatch(getWarehouses(clientId))
    }
  }, [clientId, dispatch])

  useEffect(() => {
    if (clientId && withState) {
      dispatch(getObjectsState())
    }
  }, [clientId, dispatch, withState])

  return warehouses
}

export default useWarehouses